<div class="card">
  <div class="card-body">
    <h5>{{ "ZNS NHẮC GIA HẠN GỬI LỖI (DỮ LIỆU CHO CSKH XỬ LÝ)" | translate }}</h5>
    <div class="row mb-3">
      <div class="col-12">
        <div class="row">
          <div class="col-6 col-lg-3">
            <div class="form-group">
              <label>{{ "Số tài khoản" | translate }}</label>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="filter.acc_number"
                placeholder="Nhập số tài khoản"
              />
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="form-group">
              <label>{{ "Số điện thoại" | translate }}</label>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="filter.phone"
                placeholder="Nhập số điện thoại"
              />
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="form-group">
              <label>{{ "SĐT người nhận" | translate }}</label>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="filter.receiver_phone"
                placeholder="Nhập số điện thoại người nhận"
              />
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="form-group">
              <label>{{ "Thời gian lần cuối gửi" | translate }}</label>
              <ng-select [(ngModel)]="filter.dayRange" [clearable]="true">
                <ng-option value="" hidden>
                  {{ "Chọn thời gian lần cuối gửi tin nhắn" | translate }}
                </ng-option>
                <ng-option *ngFor="let item of listDayRange" [value]="item.value">
                  {{ item.label }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-12 text-center mt-2">
            <div class="form-group">
              <button class="btn btn-primary" (click)="submitFilter()">
                {{ "PAGE.REPORT.Search" | translate }}
              </button>
              <button
                class="btn btn-dark ml-2"
                *ngIf="searching"
                (click)="clearFilter()"
              >
                {{ "FORM.Clear" | translate }}
              </button>
              <button class="btn btn-outline-success ml-2" (click)="exportExcel()">
                {{ "Xuất Excel" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table id="basic-datatable" class="table table-bordered dt-responsive zns-table">
        <colgroup>
          <col style="width: 50px" />
          <col style="width: 80px" />
          <col style="width: 150px" />
          <col style="width: 100px" />
          <col style="width: 100px" />
          <col style="width: 150px" />
          <col style="width: 60px" />
          <col style="width: 110px" />
          <col style="width: 150px" />
          <col style="width: 120px" />
        </colgroup>
        <thead>
          <tr class="bg-table">
            <th>#</th>
            <th>{{ "Số tài khoản" | translate }}</th>
            <th>{{ "Thông tin khách hàng" | translate }}</th>
            <th>{{ "Thông tin người nhận" | translate }}</th>
            <th>{{ "Trạng thái gửi ZNS" | translate }}</th>
            <th>{{ "Lỗi gửi ZNS" | translate }}</th>
            <th>{{ "Lần gửi" | translate }}</th>
            <th>{{ "Ngày hết hạn" | translate }}</th>
            <th>{{ "Thông tin gói DV" | translate }}</th>
            <th>{{ "Ngày job retry" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td class="table-column text-center">
              {{ pageSize * (pageIndex - 1) + i + 1 }}
            </td>
            <td class="table-column">{{ data.acc_number }}</td>
            <td
              class="table-column"
              [ngClass]="{ 'zns-sent-highlight': data.last_sent_phone_type === 'USER' }"
            >
              <div>{{ data.user_phone }}</div>
              <div>{{ data.full_name }}</div>
            </td>
            <td
              class="table-column"
              [ngClass]="{ 'zns-sent-highlight': data.last_sent_phone_type === 'RECEIVER' }"
            >
              <div>{{ data.receiver_phone }}</div>
              <div>{{ data.receiver_name }}</div>
            </td>
            <td class="table-column">
              <div>
                <span class="badge badge-danger font-size-12">
                  {{ "Gửi thất bại" | translate }}
                </span>
              </div>
              <div class="mt-1" *ngIf="data.send_date">
                {{ data.send_date | date : "dd/MM/yyyy HH:mm" }}
              </div>
            </td>
            <td class="table-column">{{ data?.last_error }}</td>
            <td class="table-column">{{ data.send_count || 0 }} lần</td>
            <td class="table-column">
              <div>
                <span
                  class="badge font-size-12"
                  [ngClass]="data.expire_in_days == 0 ? 'badge-danger' : 'badge-secondary'"
                >
                  Còn {{ data.expire_in_days }} ngày
                </span>
              </div>
              <div class="mt-1">
                {{ data.expiration_date | date : "dd/MM/yyyy" }}
              </div>
            </td>
            <td class="table-column">
              <div>
                <span class="badge badge-primary font-size-12">
                  {{ data.packages?.devices[0]?.device_type_name }} x
                  {{ data.packages?.devices.length }}
                </span>
              </div>
              <div class="mt-1">
                {{ data.packages?.devices[0]?.service_package }} tháng
              </div>
            </td>
            <td class="table-column">
              {{ data.job_retried_at | date : "dd/MM/yyyy HH:mm" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
